/**
 * Use to check in what environment the code is being executed
 * @someUses For printing console.errors() or not
 * @type {{which: string, isNotPro: boolean, isTest: boolean, isDev: boolean, isPro: boolean}}
 */
var environment = {
  which: process.env.NODE_ENV,
  isPro: process.env.NODE_ENV === 'production',
  isNotPro: process.env.NODE_ENV !== 'production',
  isTest: process.env.NODE_ENV === 'test',
  isDev: process.env.NODE_ENV === 'development'
};
export default environment;